import { ENUM_FILE_DATA_TYPES_BASE64_PREFIX, Base64AndExt } from '@app-lib/models/-index';

export function fnBase64ToFile(base64Image: string): Blob {
  const split = base64Image.split(',');
  const type = split[0].replace('data:', '').replace(';base64', '');
  const byteString = atob(split[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type });
}
export function fnBase64ToArrayBuffer(imageBase64: string) {
  imageBase64 = imageBase64.replace(/^data\:([^\;]+)\;base64,/gim, '');
  const binaryString = atob(imageBase64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

export function fnBase64RemoveHead(imageBase64: string) {
  return imageBase64.replace(/^data\:([^\;]+)\;base64,/gim, '');
}

// rimuove caratteri che non siano alphanumerici o _

export function fnSanitizeFilename(str: string): string {
  let r = str.replace(/[^\w.]+/g, '_');
  r = r.replace(/\.(?=.*\.)/g, '');
  // var output = r.substr(0, r.lastIndexOf('.')) || r;
  //onsole.log('fnSanitizeFilename ->' + JSON.stringify(r, null, 4));
  return r;
}

export function fnBase64AndExt(imageBase64: string): Base64AndExt {
  /*
'/' means jpeg.
'i' means png.
'R' means gif.
'U' means webp.
'Q' means bmp.
'J' means PDF. */
  if (imageBase64.startsWith('/')) {
    return {
      base64: ENUM_FILE_DATA_TYPES_BASE64_PREFIX.JPEG + imageBase64,
      extension: 'jpeg',
    };
  } else if (imageBase64.startsWith('i')) {
    return {
      base64: ENUM_FILE_DATA_TYPES_BASE64_PREFIX.PNG + imageBase64,
      extension: 'png',
    };
  } else if (imageBase64.startsWith('R')) {
    return {
      base64: ENUM_FILE_DATA_TYPES_BASE64_PREFIX.GIF + imageBase64,
      extension: 'gif',
    };
  } else if (imageBase64.startsWith('Q')) {
    return {
      base64: ENUM_FILE_DATA_TYPES_BASE64_PREFIX.BMP + imageBase64,
      extension: 'bmp',
    };
  } else if (imageBase64.startsWith('J')) {
    return {
      base64: ENUM_FILE_DATA_TYPES_BASE64_PREFIX.PDF + imageBase64,
      extension: 'pdf',
    };
  } else {
    return {
      base64: ENUM_FILE_DATA_TYPES_BASE64_PREFIX.PNG + imageBase64,
      extension: 'png',
    };
  }
}
// versione semplice per la sola ext
export function fnBase64Ext(imageBase64: string): string {
  /*
'/' means jpeg.
'i' means png.
'R' means gif.
'U' means webp.
'Q' means bmp.
'J' means PDF. */
  if (imageBase64.startsWith('/')) {
    return 'jpeg';
  } else if (imageBase64.startsWith('i')) {
    return 'png';
  } else if (imageBase64.startsWith('R')) {
    return 'gif';
  } else if (imageBase64.startsWith('Q')) {
    return 'bmp';
  } else if (imageBase64.startsWith('J')) {
    return 'pdf';
  } else {
    return null;
  }
}
